<template>
    <div class="row">
        <div class="card">
            <div class="card-header flex justify-between items-center">
                <h2>Gerar Etiquetas</h2>
            </div>
            <div class="card-body">
                <validation-observer ref="forms" v-slot="{ handleSubmit }">
                    <form
                        class="form-group"
                        @submit.prevent="handleSubmit(gerarEtiquetas)"
                    >
                        <div class="grid-1">
                            <validation-provider
                                name="Destinatários"
                                vid="destinatarios"
                                rules="required"
                                v-slot="{ errors }"
                                tag="div"
                                class="input-std form-text"
                            >
                                <label>Destinatários</label>
                                <select
                                    v-model="etiquetas.tipo"
                                    class="text-black"
                                >
                                    <option :value="null" disabled
                                        >Destinatários</option
                                    >
                                    <option value="1">SINDICATOS</option>
                                    <option value="2"
                                        >INSCRITOS DOS SINDICATO</option
                                    >
                                    <option value="3"
                                        >INSCRITOS DO EVENTO</option
                                    >
                                    <option value="4">TODOS OS CONTATOS</option>
                                </select>
                                <p class="errors">{{ errors[0] }}</p>
                            </validation-provider>

                            <validation-provider
                                name="Sindicato"
                                vid="sindicato"
                                rules="required"
                                v-slot="{ errors }"
                                tag="div"
                                class="input-std form-text"
                                v-if="etiquetas.tipo === '2'"
                            >
                                <label>Sindicato</label>
                                <select
                                    v-model="etiquetas.sindicato_id"
                                    class="text-black"
                                >
                                    <option :value="null" disabled
                                        >Sindicato</option
                                    >
                                    <option
                                        v-for="(sindicato, index) in sindicatos"
                                        :key="index"
                                        :value="sindicato.id"
                                    >
                                        {{ sindicato.nome_fantasia }}
                                    </option>
                                </select>
                                <p class="errors">{{ errors[0] }}</p>
                            </validation-provider>

                            <validation-provider
                                name="Evento"
                                vid="evento"
                                rules="required"
                                v-slot="{ errors }"
                                tag="div"
                                class="input-std form-text"
                                v-if="etiquetas.tipo === '3'"
                            >
                                <label>Evento</label>
                                <select
                                    v-model="etiquetas.evento_id"
                                    class="text-black"
                                >
                                    <option :value="null" disabled
                                        >Evento</option
                                    >
                                    <option
                                        v-for="(evento, index) in eventos"
                                        :key="index"
                                        :value="evento.id"
                                    >
                                        {{ evento.nome }}
                                    </option>
                                </select>
                                <p class="errors">{{ errors[0] }}</p>
                            </validation-provider>

                            <div class="flex justify-end">
                                <button class="btn btn-primary">
                                    Gerar Etiquetas
                                </button>
                            </div>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </div>

        <div class="card">
            <div class="card-header flex justify-between items-center">
                <h2>Lista de Contatos</h2>
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="inscritos.columns"
                    :rows="inscritos.rows"
                    :totalRows="inscritos.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum contato foi cadastrado.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-col"
                        >
                            <div
                                class="h-6 mb-2"
                                title="Visualizar Contato"
                                @click.prevent="
                                    () =>
                                        $router.push(
                                            '/sistema/eventos/visualizar-contato/' +
                                                props.row.id
                                        )
                                "
                            >
                                <svg-icon
                                    icon="search"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
export default {
    name: "lista-contatos",

    components: { VueGoodTable },

    created() {
        this.getEventos();
    },

    data() {
        return {
            sindicatos: [],
            eventos: [],
            inscritos: {
                columns: [
                    { label: "Nome", field: "nome_completo" },
                    { label: "Cargo", field: "cargo" },
                    { label: "E-mail", field: "email" },
                    { label: "Telefone", field: "telefone" },
                    { label: "Celular", field: "celular" },
                    { label: "Whatsapp", field: "whatsapp" },
                    { label: "Cidade", field: "cidade" },
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            },
            etiquetas: {
                tipo: null,
                sindicato_id: null,
                evento_id: null
            }
        };
    },

    methods: {
        getEventos() {
            this.axios("get-all-eventos")
                .then(response => {
                    this.eventos = response.data.eventos;
                    this.getSindicatos();
                })
                .catch(error => {
                    console.error(error);
                });
        },

        getSindicatos() {
            this.axios("get-all-sindicatos")
                .then(response => {
                    this.sindicatos = response.data.sindicato;
                    this.getInscritos();
                })
                .catch(error => {
                    console.error(error);
                });
        },

        getInscritos() {
            this.axios("inscritos", {
                params: {
                    page: this.inscritos.filtros.page,
                    per_page: this.inscritos.filtros.perPage,
                    sortField: this.inscritos.filtros.sort.field,
                    sortType: this.inscritos.filtros.sort.type
                }
            })
                .then(response => {
                    this.inscritos.rows = response.data.inscrito.data;
                    this.inscritos.total = response.data.inscrito.total;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarInscritos({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarInscritos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarInscritos({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os eventos conforme as mudanças
         * @param newProps
         */
        filtrarInscritos(newProps) {
            this.inscritos.filtros = Object.assign(
                {},
                this.inscritos.filtros,
                newProps
            );
            this.getInscritos();
        },

        gerarEtiquetas() {
            if (this.etiquetas.tipo === "1") {
                window.open("/sistema/gera-etiquetas/1/1");
            } else if (this.etiquetas.tipo === "2") {
                window.open(
                    "/sistema/gera-etiquetas/2/" +
                        this.etiquetas.sindicato_id +
                        ""
                );
            } else if (this.etiquetas.tipo === "3") {
                window.open(
                    "/sistema/gera-etiquetas/3/" + this.etiquetas.evento_id + ""
                );
            } else if (this.etiquetas.tipo === "4") {
                window.open("/sistema/gera-etiquetas/4/1");
            }
        }
    }
};
</script>
<style scoped lang="scss">
.icon-table {
    @apply w-5;
}
</style>
